import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import { Col, Row } from 'antd';
import { omitBy } from 'lodash';

import FormItem, { TYPE_INPUT } from 'components/FormItem';

import RefreshIcon from 'resources/svg/refresh_icon.svg';

import { useChangeAddress } from 'hooks/useChangeAddress';
import { ORDERS } from 'utils';
import { NFTParamsTypes } from 'pages/nft-management';
import LENGTH_CONSTANTS from 'constants/length';
import { NFT_MANAGEMENT_FIELD } from 'constants/nft';

const { KEYWORD, PAGE } = NFT_MANAGEMENT_FIELD;
const { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } = LENGTH_CONSTANTS;
const { FIELD, ORDER } = ORDERS;

type SearchFormProps = {
  onSubmit: (values: any) => void;
  params: NFTParamsTypes;
  formRef: any;
};

const initialValues = {
  keyword: '',
  page: DEFAULT_PAGE,
  limit: DEFAULT_PAGE_SIZE,
};

const SearchForm = ({ onSubmit, params, formRef }: SearchFormProps) => {
  const { t } = useTranslation();

  const handleChangeField =
    (setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void, field: string) =>
    (value: string) => {
      setFieldValue(field, value?.trim());
      onSubmit({
        ...params,
        [field]: value?.trim(),
        [PAGE]: DEFAULT_PAGE,
      });
    };

  const handleResetForm = () => {
    formRef?.current?.resetForm();
    onSubmit({
      ...omitBy(params, [FIELD, ORDER]),
      ...initialValues,
      [PAGE]: DEFAULT_PAGE,
    });
  };

  useChangeAddress({ callback: handleResetForm });

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} innerRef={formRef}>
      {({ setFieldValue }) => (
        <Form className="search-form nft-management-search-form">
          <Row gutter={20} className="nft-management-search-form__row">
            <Col lg={8} sm={12} xs={24}>
              <FormItem
                name={KEYWORD}
                className="search-form__name--input"
                placeholder={t('whitelist.txt_search_placeholder')}
                onSearch={handleChangeField(setFieldValue, KEYWORD)}
                typeInput={TYPE_INPUT.SEARCH}
              />
            </Col>
            <Col lg={10} sm={24} xs={24} className="nft-management-search-form__group-button">
              <img src={RefreshIcon} onClick={handleResetForm} className="cursor-pointer" />
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default SearchForm;
